import React from "react";
import PropTypes from "prop-types";
import authActions from "../../../redux/futures/auth/actions";
import _ from "lodash";
import { connect } from "react-redux";
import baseHelper from "../../../helpers/BaseHelper";
import appConst from "../../../config/const";
import queryString from "query-string";


import * as types from "../../../redux/futures/auth/types";
import i18n from "../../../i18n";

class ModalAuthenApplication extends React.Component {

  constructor(props) {
    super(props);

    const parsed = queryString.parse(this.props.location?.search || '');

    let token = false;
    if (parsed.token && parsed.token != '') {
      token = parsed.token;
    }

    this.state = {
      dataAuth: {},
      codeAuth: ['', '', '', '', '', ''],
      token,
      stepSelected: 1,
      search: this.props.location?.search || '',
      loading: false,
      classNormal: "ladiui btn btn-primary full-width",
      classLoading: "ladiui loader btn btn-primary full-width",
      classApply: "ladiui btn btn-primary full-width",
    };
    this.inputRefs = [];
    this.ref = React.createRef();
  }
  componentDidMount() {

  }
  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dataAuth !== nextProps.dataAuth) {
      console.log(' nextProps.CJAGE dataAuth = ', nextProps.dataAuth)
      this.setState({ dataAuth: nextProps.dataAuth });
    }
  }

  handleNextStep = (value) => {
    this.setState({ stepSelected: value });
    this.setState({ codeAuth: ['', '', '', '', '', ''] });
  }


  handleClose = () => {
    // Hide current modal

    this.setState({ codeAuth: ['', '', '', '', '', ''] });
    window.LadiUI.closeModal('modal-authen-application');
  };
  componentWillUnmount() {
  }

  componentDidUpdate() {
    window.LadiUI.init();


  }

  handleInputCode = (index, e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    if (value.length > 1) return;

    const { codeAuth } = this.state;
    const newCode = [...codeAuth];
    newCode[index - 1] = value;
    this.setState({ codeAuth: newCode });

    if (value && index < 6) {
      this.inputRefs[index].focus();
    }
  };

  handleKeyDown = (index, e) => {
    const { codeAuth } = this.state;
    if (e.key === 'Backspace' && !codeAuth[index - 1] && index > 1) {
      this.inputRefs[index - 2].focus();
    }
  };

  handlePaste = (e) => {
    const paste = e.clipboardData.getData('text');
    if (paste.length === 6 && /^\d+$/.test(paste)) {
      const newCode = paste.split('');
      this.setState({ codeAuth: newCode });
      this.inputRefs[5].focus();
      e.preventDefault();
    }
  };

  handleConfirmActive = () => {
    const { codeAuth } = this.state;
    let otpCode = codeAuth.join('');
    if (otpCode) {
      this.props.activeAuth(otpCode);
    }
    this.setState({ codeAuth: ['', '', '', '', '', ''] });
  }

  handleCopySecret = () => {
    const { dataAuth } = this.state;
    if (dataAuth.secret) {
      navigator.clipboard.writeText(dataAuth.secret);
      window.LadiUI.toast('success', i18n.t('LADIFLOW_BASE.Thông báo'), i18n.t('TWO_FA_AUTH.COPY_SUCCESS'), 3000, 'top-right');
    }
  }

  render() {
    const { dataAuth, codeAuth, stepSelected } = this.state;
    // console.log(email);
    return (
      <div className={`ladiui modal`} id='modal-authen-application'>
        <div className="ladiui modal-dialog modal-dialog-centered">
          <div className="ladiui modal-content">
            <div className="ladiui modal-header custom-v4">
              <div className="title-description-modal">
                <div className="ladiui title-2 color-900 font-600 text-15">{i18n.t('TWO_FA_AUTH.TITLE')}</div>
                <p>{i18n.t('TWO_FA_AUTH.DESC')}</p>
              </div>
              <button
                type="button"
                data-dismiss="modal"
                data-target="modal-authen-application"
                className="ladiui modal-close"
                style={{ "top": "18px", "right": "0px" }}
                onClick={this.handleClose}
              >
                <img
                  src="https://w.ladicdn.com/ladiui/icons/new-ldicon-close-fill-2.svg"
                  className="mr-0"
                  alt=""
                />
              </button>
            </div>

            <div className="ladiui modal-body">
              {
                stepSelected === 1
                &&
                <div className='block-step'>
                  <div className='title-step'>
                    <span>{i18n.t('TWO_FA_AUTH.STEP_1')}</span>
                    <p>{i18n.t('TWO_FA_AUTH.SCAN_QR')}</p>
                  </div>
                  <div className='description' style={{ marginBottom: '0px' }}>
                    {i18n.t('TWO_FA_AUTH.SCAN_QR_DESC')}
                  </div>
                  <div style={{ marginBottom: '16px' }}>
                    <a href={appConst.GOOGLE_AUTHENTICATOR_URL} target='_blank' rel='noopener noreferrer'>{i18n.t('TWO_FA_AUTH.DOWNLOAD_ANDROID')}</a>
                    &nbsp;hoặc&nbsp;
                    <a href={appConst.APPLE_AUTHENTICATOR_URL} target='_blank' rel='noopener noreferrer'>{i18n.t('TWO_FA_AUTH.DOWNLOAD_IOS')}</a>
                  </div>
                  <div className='description' style={{ marginBottom: '0px' }}>
                    {i18n.t('TWO_FA_AUTH.SCAN_QR_DESC_2')}
                  </div>
                  <div className='qr-code'>
                    <div className='text-center'>
                      <div className='image'>
                        <img src={dataAuth && dataAuth.qrCode ? dataAuth.qrCode : ''} alt='' style={{ width: '100%', height: '100%' }} />
                      </div>
                      {i18n.t('TWO_FA_AUTH.QR_CODE')}
                    </div>
                  </div>

                  <div className='secret-code mt-16'>
                    <p>{i18n.t('TWO_FA_AUTH.CANNOT_SCAN_QR')}</p>
                    <span>{i18n.t('TWO_FA_AUTH.ENTER_SECRET_KEY')}</span>
                    <div className='flex w100 gap-16'>
                      <input className='ladiui form-control' type='text' value={dataAuth && dataAuth.secret ? dataAuth.secret : ''} disabled />
                      <button className='ladiui btn btn-ghost' onClick={this.handleCopySecret}>{i18n.t('TWO_FA_AUTH.COPY_SECRET')}</button>
                    </div>
                  </div>
                </div>
              }

              {
                stepSelected === 2
                &&
                <div className='block-step'>
                  <div className='title-step'>
                    <span>{i18n.t('TWO_FA_AUTH.STEP_2')}</span>
                    <p>{i18n.t('TWO_FA_AUTH.ENTER_AUTH_CODE')}</p>
                  </div>
                  <div className='description'>
                    {i18n.t('TWO_FA_AUTH.ENTER_AUTH_CODE_DESC')}
                  </div>
                  <div className='block-enter-authen-code'>
                    <p>{i18n.t('TWO_FA_AUTH.AUTH_CODE')}</p>
                    <div className='code-container' onPaste={this.handlePaste}>
                      <input type="text" className="code-input" maxLength="1" value={codeAuth[0]} onChange={(e) => this.handleInputCode(1, e)} ref={(ref) => this.inputRefs[0] = ref} onKeyDown={(e) => this.handleKeyDown(1, e)} />
                      <input type="text" className="code-input" maxLength="1" value={codeAuth[1]} onChange={(e) => this.handleInputCode(2, e)} ref={(ref) => this.inputRefs[1] = ref} onKeyDown={(e) => this.handleKeyDown(2, e)} />
                      <input type="text" className="code-input" maxLength="1" value={codeAuth[2]} onChange={(e) => this.handleInputCode(3, e)} ref={(ref) => this.inputRefs[2] = ref} onKeyDown={(e) => this.handleKeyDown(3, e)} />
                      <input type="text" className="code-input" maxLength="1" value={codeAuth[3]} onChange={(e) => this.handleInputCode(4, e)} ref={(ref) => this.inputRefs[3] = ref} onKeyDown={(e) => this.handleKeyDown(4, e)} />
                      <input type="text" className="code-input" maxLength="1" value={codeAuth[4]} onChange={(e) => this.handleInputCode(5, e)} ref={(ref) => this.inputRefs[4] = ref} onKeyDown={(e) => this.handleKeyDown(5, e)} />
                      <input type="text" className="code-input" maxLength="1" value={codeAuth[5]} onChange={(e) => this.handleInputCode(6, e)} ref={(ref) => this.inputRefs[5] = ref} onKeyDown={(e) => this.handleKeyDown(6, e)} />
                    </div>
                  </div>
                </div>
              }
            </div>

            <div className="ladiui modal-footer justify-end custom-v4">
              {
                stepSelected === 1
                  ?
                  <button
                    className="ladiui btn btn-primary w100"
                    onClick={() => this.handleNextStep(2)}
                  >
                    {i18n.t('TWO_FA_AUTH.CONTINUE')}
                  </button>
                  :
                  <div className='flex items-center gap-16 w100'>
                    <button
                      className="ladiui btn btn-secondary w100 mr-0"
                      onClick={() => this.handleNextStep(1)}
                    >
                      {i18n.t('TWO_FA_AUTH.BACK')}
                    </button>
                    <button
                      className="ladiui btn btn-primary w100"
                      onClick={() => this.handleConfirmActive()}
                    >
                      {i18n.t('TWO_FA_AUTH.CONFIRM')}
                    </button>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    generateTOTP: (data) =>
      dispatch(authActions.generateTOTP(data)),
  };
};

const mapStateToProps = (state) => ({ ...state.auth });

export default connect(mapStateToProps, mapDispatchToProps)(ModalAuthenApplication);